var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"errorpage"}},[_c('img',{attrs:{"src":"/dist/img/404.png"}}),_c('h2',[_vm._v("页面走丢了")])])
}]

export { render, staticRenderFns }